var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSparkleAi = function SvgSparkleAi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#sparkle-ai_svg__a)",
    filter: "url(#sparkle-ai_svg__b)",
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.687 2.837a1 1 0 0 0-1.974 0c-.1.608-.32 1.015-.598 1.29-.279.277-.686.489-1.278.586a1 1 0 0 0 0 1.974c.608.1 1.015.32 1.29.598.277.279.489.686.586 1.278a1 1 0 0 0 1.974 0c.097-.592.31-1 .586-1.279.275-.278.682-.497 1.29-.597a1 1 0 0 0 0-1.974c-.608-.1-1.015-.32-1.29-.598-.277-.279-.489-.686-.586-1.278Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.892 2.874a1 1 0 0 0-1.984 0c-.322 2.534-1.006 4.36-2.118 5.642-1.098 1.265-2.714 2.115-5.145 2.496a1 1 0 0 0 0 1.976c2.431.381 4.047 1.231 5.145 2.496 1.112 1.281 1.796 3.108 2.118 5.642a1 1 0 0 0 1.984 0c.322-2.534 1.006-4.36 2.118-5.642 1.098-1.265 2.714-2.115 5.145-2.496a1 1 0 0 0 0-1.976c-2.563-.402-4.181-1.306-5.248-2.585-1.086-1.304-1.706-3.12-2.015-5.553Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sparkle-ai_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "sparkle-ai_svg__b",
    width: 30,
    height: 30,
    x: -3,
    y: 1,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_21"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1_21",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSparkleAi);
export default ForwardRef;